import Hero from './components/Hero';
import FeatureCards from './components/FeatureCards';
import HowItWorks from './components/HowItWorks';
import CategoryGrid from './components/CategoryGrid';
import ComparisonTable from './components/ComparisonTable';
import SafetySection from './components/SafetySection';
import BlogCards from './components/BlogCards';
import FAQ from './components/FAQ';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'VigorBuy Spreadsheet Resource Hub',
  url: import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.cfd',
  description:
    'VigorBuy Spreadsheet resources including product lists, buying guides, comparisons and expert tutorials.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.cfd'}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.cfd';
  const siteSchema = {
    ...webSiteSchema,
    url: siteUrl,
    potentialAction: {
      ...webSiteSchema.potentialAction,
      target: `${siteUrl}/search?q={search_term_string}`,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(siteSchema)}</script>
      <Navbar />
      <main>
        <Hero />

        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-5">
                What Is VigorBuy Spreadsheet?
              </h2>
              <p className="text-foreground-500 leading-relaxed text-base md:text-lg">
                <strong>VigorBuy Spreadsheet</strong> is a structured product research resource that helps users
                organize, compare and discover products more efficiently. Instead of searching through scattered
                information across multiple websites, users can explore categorized lists, comparison tables and detailed
                guides designed to simplify product research. Whether you are looking for the latest shoes, trendy
                hoodies, or essential accessories, the spreadsheet format puts everything you need in one convenient
                place.
              </p>
            </div>
          </div>
        </section>

        <FeatureCards />
        <HowItWorks />
        <CategoryGrid />
        <ComparisonTable />
        <SafetySection />
        <BlogCards />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}